module.exports = __webpack_public_path__ + "img/Big Picture Thinker.b44deaf0.svg";